











import { Vue, Component, Prop } from "vue-property-decorator";

import { GridModel, DataFilter } from "@/core/models";

@Component
export default class GridSearchCpt extends Vue {
  @Prop() grid: GridModel<any, DataFilter>;
  @Prop({ default: "Search" }) placeholder?: string;
  dataFilter = this.grid.filter;
  debounce: number | undefined;

  onChange() {
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      this.grid.onSearch(this.dataFilter);
    }, 350);
  }

  onClear() {
    this.grid.onSearch("");
  }
}
